import { COLORS, primaryContainedButtonSx } from "assets";

export const fieldSx = { height: 44, minHeight: 44 };
export const iconSx = { fontSize: 18, color: COLORS.surface.secondaryText };

export const primaryBtnSx = {
  minWidth: 120,
  height: 44,
  borderRadius: `${COLORS.radius.sm}px`,
  fontWeight: 600,
  fontSize: 14,
  textTransform: "none",
  ...primaryContainedButtonSx
};

export const authFormLinkSx = {
  color: COLORS.primary,
  fontSize: 13,
  fontWeight: 500,
  textDecoration: "none",
  "&:hover": { color: COLORS.gradients.button.left, textDecoration: "underline" }
};

/** Back link inside the white auth card (mockup style). */
export const authFooterLinkSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  color: COLORS.primary,
  fontSize: 13,
  fontWeight: 500,
  textDecoration: "none",
  "&:hover": { color: COLORS.gradients.button.left, textDecoration: "underline" }
};

export const outlinedBtnSx = {
  height: 44,
  borderRadius: `${COLORS.radius.sm}px`,
  fontWeight: 500,
  fontSize: 14,
  textTransform: "none",
  borderColor: COLORS.surface.border,
  color: COLORS.surface.primaryText,
  bgcolor: COLORS.surface.card,
  backgroundImage: "none",
  "&:hover": {
    borderColor: COLORS.surface.secondaryText,
    bgcolor: COLORS.surface.tableHeader,
    backgroundImage: "none"
  }
};

/** Compact spacing for auth form stacks. */
export const authStackSpacing = 1.75;
